import img from "../../../img/moneybag.svg";
import img2 from "../../../img/piechart.svg";
import img3 from "../../../img/reapet.svg";
import image from "../../../img/applevektor.svg";
import image2 from "../../../img/google.svg";
import image3 from "../../../img/tesla.svg";

export const invest = [
  {
    img: img,
    title: "Total Invested Amount",
    price: "$150,000",
    bg: "rgb(220, 250, 248)",
  },
  {
    img: img2,
    title: "Number of Investments",
    price: "1,250",
    bg: "rgb(255, 224, 235)",
  },
  {
    img: img3,
    title: "Rate of Return",
    price: "+5.80%",
    bg: "rgb(231, 237, 255)",
  },
];
export const myInvest = [
  {
    image: image,
    name: "Apple Store",
    text: "E-commerce, Marketplace",
    price: "$54,000",
    title: "Envestment Value",
    number: "+16%",
    numbertext: "Return Value",
    bg: "rgb(255, 224, 235)",
  },
  {
    image: image2,
    name: "Samsung Mobile",
    text: "E-commerce, Marketplace",
    price: "Samsung Mobile",
    title: "Envestment Value",
    number: "-4%",
    numbertext: "Return Value",
    bg: "rgb(231, 237, 255)",
  },
  {
    image: image3,
    name: "Tesla Motors",
    text: "Electric Vehicles",
    price: "$8,200",
    title: "Envestment Value",
    number: "+25%",
    numbertext: "Return Value",
    bg: "rgb(255, 245, 217)",
  },
];
export const trending = [
  {
    number: "01.",
    name: "Trivago",
    price: "$520",
    return: "+5%",
    color: "rgb(22, 219, 170)",
  },
  {
    number: "02.",
    name: "Canon",
    price: "$480",
    return: "+10%",
    color: "rgb(22, 219, 170)",
  },
  {
    number: "03.",
    name: "Uber Food",
    price: "$350",
    return: "-3%",
    color: "rgb(254, 92, 115)",
  },
  {
    number: "04.",
    name: "Nokia",
    price: "$940",
    return: "+2%",
    color: "rgb(22, 219, 170)",
  },
  {
    number: "05.",
    name: "Tiktok",
    price: "$670",
    return: "-12%",
    color: "rgb(254, 92, 115)",
  },
];
